import React, { useCallback, useEffect, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Rate, Icon, Radio, Tooltip, Col, Row, Button, message, Select, Upload } from 'antd'
import styles from './styles.module.scss'
import dayjs from 'dayjs'
import * as apis from '@/apis'
import * as services from '@/models/orders/services';
import UploadImage from "@/components/UploadImage/Upload";

const { Option } = Select;
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },

};


const InfoDialog = (props) => {
  const { modal, isOpen, form, orderId, workerId, ...ownProps } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue, resetFields } = form;
  const [evaluateInfo, setEvaluateInfo] = useState({});

  const initData = async () => {
    services.getEvaluateInfo({ orderId })
      .then((result) => {
        setEvaluateInfo(result.data || {})
      })
      .catch((err) => {
        message.error(err.message || '获取数据失败，请刷新重试');
      })
      .finally(() => {
      });
  }

  const handleSubmit = () => {
    validateFields((err, values) => {

      if (err) {
        return console.error(err)
      }
      const queryData = { ...values, orderId: orderId, workerId: workerId }
      queryData.images = queryData.images.map(item => item.url)
      props.submit(queryData)

    });
  }

  useEffect(() => {
    initData()
  }, [])

  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      width={520}
      visible={isOpen}
      onOk={() => { handleSubmit() }}
      onCancel={props.hide}

      mask={false}
      wrapClassName="order-detail-modal-wrap"
      maskStyle={{ position: 'absolute' }}
      getContainer={() => document.getElementById('order-detail-wrap') || window}
    >
      <div>
        <Form
          {...formItemLayout}
        >
          <Row>
            <Col span={12}>
              <Form.Item label="专业技术">
                {getFieldDecorator('technology', {
                  initialValue: evaluateInfo.technology,
                  rules: [
                    { required: true, message: `请选择专业技术`, },
                  ],
                })(<Rate style={{ color: '#FF6600' }} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="服务态度">
                {getFieldDecorator('manner', {
                  initialValue: evaluateInfo.manner,
                  rules: [
                    { required: true, message: `请选择服务态度`, },
                  ],
                })(<Rate style={{ color: '#FF6600' }} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="处理速度">
                {getFieldDecorator('speed', {
                  initialValue: evaluateInfo.speed,
                  rules: [
                    { required: true, message: `请选择处理速度`, },
                  ],
                })(<Rate style={{ color: '#FF6600' }} />)}
              </Form.Item>
            </Col>

          </Row>
          <Form.Item
            label="客户评价"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            {getFieldDecorator('comment', {
              initialValue: evaluateInfo.comment,
              rules: [
                { required: true, message: `请输入评价文字`, }
              ],
            })(
              <Input.TextArea rows={4} placeholder={`请输入评价文字`} />
            )}
          </Form.Item>

          <Form.Item
            label="相关照片"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            {getFieldDecorator('images', {
              initialValue: evaluateInfo.images,
              rules: [
                { required: true, message: `请上传相关照片` },
              ],
            })(
              <UploadImage />
            )}
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}

export default sagaModal({
  name: 'ORDER_EVALUATE_DIALOG',
})(Form.create()(InfoDialog))
